import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { IToast, LayoutService, ToastService } from 'codex-lib';
import { Envelope } from '../model/envelope';
import { EnvelopeService } from '../services/envelope.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-envelope-details-archived',
  templateUrl: './envelope-details-archived.component.html',
  styleUrls: ['./envelope-details-archived.component.scss']
})
export class EnvelopeDetailsArchivedComponent implements OnInit {

  @Input() elementSelected: Envelope;
  @Output() modalCloseEmmiter = new EventEmitter();
  @Output() deleteEnvelope = new EventEmitter();

  envelopeForm: FormGroup;
  envelopeDetail: Envelope;

  envelope = { id: 0, reasonArchived: '' };

  constructor(
    private modalService: NgbModal,
    private translateService: TranslateService,
    private envelopeService: EnvelopeService,
    private layoutService: LayoutService,
    private toastService: ToastService) { }

  get id() {
    return this.envelopeForm.get('id');
  }
  get reasonArchived() {
    return this.envelopeForm.get('reasonArchived');
  }

  ngOnInit(): void {
    this.envelope.id = this.elementSelected.id;

    this.envelopeForm = new FormGroup({
      id: new FormControl(this.envelope.id, Validators.required),
      reasonArchived: new FormControl(this.envelope.reasonArchived, Validators.required)
    });
  }

  onArchivedEnvelope() {

    this.layoutService.toggleLoading(true);

    if (this.envelopeForm.valid) {
      this.envelopeService
        .archived(this.id.value, this.reasonArchived.value)
        .subscribe(
          response => {
            this.layoutService.toggleLoading(false);
            const toast: IToast = {
              text: this.translateService.instant('envelope.archived-modal.toast.archivedSucess'),
              autoHide: true,
              type: 'success'
            };
            this.toastService.createNewToast(toast);
            this.deleteEnvelope.emit();
            this.modalService.dismissAll();
          },
          error => this.layoutService.toggleLoading(false)
        );
    }
  }

  modalClose() {
    this.modalCloseEmmiter.emit(true);
    this.modalService.dismissAll();
  }

}
